export * from './baPageTop.component';



// WEBPACK FOOTER //
// /app/src/app/theme/components/baPageTop/index.ts